import * as S from './styled'
//Icons
import { X } from '@phosphor-icons/react';

interface ILayoutModal {
    title: string;
    subTitle: string;
    children: React.ReactNode;
    setModalClose: () => void;
}

export default function LayoutWithList(
    {
        title,
        subTitle,
        children,
        setModalClose,
    }: ILayoutModal) {
    return (
        <S.Container>
            <S.Content>
                <S.Header>
                    <S.infor>
                        <S.Title>
                            {title}
                        </S.Title>
                        <S.SubTitle>
                            {subTitle}
                        </S.SubTitle>
                    </S.infor>
                    <S.ButtonClose onClick={setModalClose}>
                        <X size={24} />
                    </S.ButtonClose>
                </S.Header>
                {children}
            </S.Content>
        </S.Container>
    )
}